import {
  anEntityInterface,
  anInsight,
  aSignal,
  ContentType,
  mockSignalAsideQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { handlers as tagsHandlers } from '@sbu/hooks.tags/build/mocks';
import { handlers as ruleLabelHandlers } from '@sbu/views.rulelabel/build/mocks';

export const mockSignal = aSignal({
  id: 'e88c87e1-cd90-5d7b-b179-42e5a15d439e',
  name: 'Password Attack Test',
  created: '2023-06-28T10:29:19.207000',
  summary: 'Password attack from IP: 1.1.1.1 host: DAV-LAP124',
  entity: anEntityInterface({
    id: '_ip-1.1.1.1',
    entityType: '_ip',
    entityTypeName: 'IP Address',
    name: '1.1.1.1',
  }),
  severity: 4,
  ruleId: 'THRESHOLD-S00095',
  ruleType: 'THRESHOLD',
  contentTypeEnum: ContentType.Rule,
  insights: [
    anInsight({
      id: '1234',
      readableId: 'INSIGHT-151834',
      name: 'Lateral Movement with Initial Access',
    }),
  ],
  timestamp: '2023-06-28T15:12:21.016000',
  suppressed: true,
  suppressedBySignal: aSignal({
    id: 'e423c12a-a3e2-51ac-8191-0c1d2c75e775',
    name: 'fda',
    contentTypeEnum: ContentType.Rule,
    insights: [
      anInsight({
        id: '5678',
        readableId: 'INSIGHT-C1023354',
        name: 'Lateral Movement with Initial Access',
      }),
    ],
  }),
  isSuppressedBySuppressList: false,
  suppressedByNetworkBlock: false,
  isSuppressedByEntity: false,
  tags: [
    '_mitreAttackTactic:TA0001',
    '_mitreAttackTactic:TA0006',
    '_mitreAttackTechnique:T1110',
    '_mitreAttackTechnique:T1078',
    '_mitreAttackTechnique:T1078.001',
    '_mitreAttackTechnique:T1078.002',
    '_mitreAttackTechnique:T1078.003',
    '_mitreAttackTechnique:T1078.004',
    '_mitreAttackTechnique:T1586',
    '_mitreAttackTechnique:T1586.001',
    '_mitreAttackTechnique:T1586.002',
    '_mitreAttackTactic:TA0008',
    '_mitreAttackTechnique:T1110.003',
    '_mitreAttackTechnique:T1110.002',
    '_mitreAttackTechnique:T1110.001',
  ],
});

export const handlers = [
  mockSignalAsideQuery(async ({ query: _query, variables: _variables }) => {
    await delay(1500);
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        signal: mockSignal,
      },
    });
  }),
  ...tagsHandlers,
  ...ruleLabelHandlers,
];
